import React from "react";
import "./sidebar.styles.css";
import { Button } from "../Button";
import { connect } from "react-redux";

class OnboardingSidebar extends React.Component {
  handleVerificationStatus(unit) {
    const { profileUnits } = this.props;
    let isVerified = false;

    profileUnits.forEach((el) => {
      if (el.unit === unit && el.provided) {
        isVerified = true;
      }
    });

    return isVerified;
  }
  render() {
    const items = [
      {
        title: "Business Category",
        description: "Choose a business category",
        active: true,
      },
      {
        title: "Business Profile",
        description:
          "Introduce your business to our platform by filling in essential details.",
        active: this.handleVerificationStatus("BUSINESS_PROFILE"),
      },
      {
        title: "Account Approval",
        description: "We'll review your account and notify you upon approval.",
        active: this.handleVerificationStatus("COMPLIANCE"),
      },
    ];
    return (
      <div className="onboarding-sidebar-container hidden-xs hidden-sm">
        <div className="onboarding-sidebar-middle-container">
          {items.map((el, i) => {
            return (
              <div className="onboarding-sidebar-item-container" key={i}>
                {el.active && i !== items.length - 1 && (
                  <div className="onboarding-sidebar-item-border-separator" />
                )}
                <div
                  className={`onboarding-sidebar-item-icon-container ${
                    el.active && "active"
                  }`}
                >
                  <span>{i + 1}</span>
                </div>
                <div className="onboarding-sidebar-item-text-container">
                  <p className="text-bold">{el.title}</p>
                  <p className="gray-text">{el.description}</p>
                </div>
              </div>
            );
          })}
        </div>
        <div className="onboarding-sidebar-footer-container">
          <div
            style={{
              display: "flex",
              gap: ".5rem",
              flexDirection: "column",
              marginBottom: "1rem",
            }}
          >
            <h3 className="text-bold">Having Trouble?</h3>
            <p>
              Feel free to contact us and we will always help you through the
              process
            </p>
          </div>
          <Button
            text="Contact Us"
            className="btn-transparent btn-bordered primary btn-sm"
            onPress={() =>
              (window.location.href = "mailto:support@dataintegrated.co.ke")
            }
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { profileUnits } = state.ProfileUnits;
  return {
    profileUnits,
  };
};

export default connect(mapStateToProps)(OnboardingSidebar);
